<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import axios from "axios";
import moment from 'moment'
import Fields from "@/helpers/fields";
import { todoMethods, todoComputed } from "@/state/helpers";
import Vue from 'vue';
import VueSweetalert2 from 'vue-sweetalert2';
// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2);



export default {
  page: {
    title: "Mujeres",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },

  components: {
    Layout,
    PageHeader,
    // tableWoman,
  },

  data() {
    return {
      filters: {
        total: { value: "", keys: ["total"] },
      },

      post: [],

      // ************************************** Link
      title: "Mujeres",
      items: [
        {
          text: "Escritorio",
          href: "/",
        },
        {
          text: "Mujeres",
          active: true,
        },
      ],
      tableWoman: [],
      info: null,
      showModal: false,
      isLoading: false,
      fullPage: true,
      canCancel: false,
      totalRows: 1,
      todoTotalRows: 1,
      currentPage: 1,
      todocurrentPage: 1,
      current: 0,
      perPage: 10,
      statData: 1,
      todoperPage: 10,
      pageOptions: [10, 25, 50, 100],
      todoOptions: [10, 50, 100, 150, 200],
      filter: "",
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortBy: "age",
      sortDesc: false,
      useSlot: false,
      loader: "spinner",
      color: "#007bff",
      bgColor: "#FFFFFF",
      height: 128,
      width: 128,
      timeout: 3000, //ms
      fetchingStats: true,
      earningStatus: true,
      womanFields: Fields.womanFields,
      totalRegistros: 0,
      defaultButtonText: 'Registro Masivo',
      selectedFile: null,
      isSelecting: false
    };
  },

  computed: {
    ...todoComputed,

    buttonText() {
      return this.defaultButtonText
    },

    rows() {
      return this.tableWoman.length;
    },
    todoList() {
      return this.todos.length;
    },

    permit() {
      // give me the value of permit in permits local storage
      const permits = JSON.parse(localStorage.getItem("permits"));
      if(permits.permit === 'admin') return 1
      else if (permits.permit === 'empresa') return 2
      else if (permits.permit === 'negocio') return 3
      else if (permits.permit === 'punto') return 4
      else if (permits.permit === 'municipio') return 6
      else if (permits.permit === 'gerente') return 7
      else if (permits.permit === 'admin_municipio') return 8
      else return 0
    },

    currentPageTotal() {
      return (this.currentPage - 1) * this.perPage;
    },
  },
  filters: {
    moment: function (date) {
      moment.locale('es');
      return moment(date).format('LL');
    }
  },
  beforeMount() {
    if(this.permit === 7) this.$router.push('/UsuariosAdmin')
    else if(this.permit === 2) this.$router.push('/buscadorTarjetas')
    else if(this.permit === 3) this.$router.push('/PuntosVenta')
    // else if(this.permit === 1) this.$router.push('/buscadorMujeres')
  },
  mounted() {
    this.getTable();
    document.getElementById("b_table_mujeres").firstElementChild.classList.add("table-light");
  },
  watch: {
    currentPage: {
      handler: function() {
        this.getTable()
      }
    },
    perPage: {
      handler: function() {
        this.getTable()
      }
    },
  },

  methods: {
    ...todoMethods,

    onButtonClick() {
      this.isSelecting = true;
      window.addEventListener('focus', () => {
        this.isSelecting = false;
      }, { once: true })

      this.$refs.uploader.click()
    },
    onFileChanged(e) {
      this.isSelecting = true;
      this.selectedFile = e.target.files[0];

      const data = new FormData();
      data.append('file', this.selectedFile);

      const config = {
          method: 'post',
          url: 'http://ec2-18-237-53-89.us-west-2.compute.amazonaws.com:3010/app/csv',
          headers: { 
            'Content-Type':'multipart/form-data'
          },
          data : data
        };
      
      axios(config)
      .then((res) => {
        this.isSelecting = false;
        const { response = "" } = res.data;
        if (response === true) {
          console.log(res);
        } else {
          this.$swal("Alertas", "No se pudo eliminar", "warning");
        }
      })
      .catch((err) => {
        this.isSelecting = false
        console.log(err);
        this.$swal("Error", "Ocurrio un error", "error");
      });
      this.isSelecting = false
    },

    handleInput(value, data) {
      this.editableDataItems[data.index][data.field.key] = value;
    },

    handleEdit(id_usuario){
      this.$router.push({
        name:'ActualizaMTarjeta',
        params:{
          id_usuario
        }
      })
    },

    handleDelete(id_usuario) {
      this.$swal({
        title: "¿Estas seguro de borrar?",
        text: "",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, borrar",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.isConfirmed) {
          axios.put("/usuarios", { id_usuario, active: "0" })
            .then((res) => {
              const { response = "" } = res.data;
              if (response === true) {
                this.$swal(
                  "Eliminado",
                  "Usuario eliminado correctamente",
                  "success"
                );
                this.$router.push({ name: "Mujeres" });
                this.getTable();
              } else {
                this.$swal("Alertas", "No se pudo eliminar", "warning");
              }
            })
            .catch((err) => {
              console.log(err);
              this.$swal("Error", "Ocurrio un error", "error");
            });
        }
      });
    },

    getTable(){
      this.isLoading = true;
      axios.get(`/usuarios?id_tipo=5&limit=${this.perPage}&offset=${this.currentPageTotal}`)
      .then((response) => {
        //this.fecha_creacion = response.data.data.fecha_creacion;
        this.tableWoman = response.data.data;
        this.totalRegistros = response.data.total_registros
        this.isLoading = false;
      }).catch(err =>{
        console.log(err);
        this.empty = 'No hay registros'
      })
    },
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <v-row>
      <v-col md="12">
        <v-card>
          <div class="card-body">
            <v-row>
              <v-col md="6">
                <h4 class="card-title mb-4">Lista de Mujeres</h4>
              </v-col>
              <v-col md="6 text-md-end">
                <router-link to="/NuevaMTarjeta">
                  <v-btn depressed color="primary" id="button-addon2">
                    Nuevo registro
                  </v-btn>
                </router-link>
                <v-divider class="mx-2" inset vertical></v-divider>
                  <v-btn
                    color="success"
                    class="text-none"
                    round
                    depressed
                    :loading="isSelecting"
                    v-if="this.permit === 1 || this.permit === 8 || this.permit === 4"
                    @click="onButtonClick"
                  >
                    <v-icon left>
                      mdi-cloud-upload
                    </v-icon>
                    {{ buttonText }}
                  </v-btn>
                  <input
                    ref="uploader"
                    class="d-none"
                    type="file"
                    accept="csv"
                    @change="onFileChanged"
                  >
              </v-col>
            </v-row>

            <v-row>
              <v-col md="6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Ver
                    <v-divider class="mx-1" inset horizontal></v-divider>
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select>
                    <v-divider class="mx-1" inset horizontal></v-divider>
                    registros
                  </label>
                </div>
              </v-col>
              <!-- Search -->
              <v-col md="6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Buscar:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Buscar..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </v-col>
            </v-row>
            <!-- End search -->
            <!-- <div class="d-flex justify-content-center align-items-center h-50" v-if="isLoading == true">
              <b-spinner variant="primary"></b-spinner>
            </div> -->
            <v-row>
              <v-col md="12">
                <b-table
                  id="b_table_mujeres"
                  :fields="womanFields"
                  :items="tableWoman"
                  :filter="filter"
                  :current-page="0"
                  :per-page="perPage"
                >
                  <template #cell(folio_tarjeta)="data">
                    <a href="javascript: void(0);" class="text-body fw-bold">
                      {{ data.item.folio_tarjeta }}
                    </a>
                  </template>
                  <template #cell(fecha_creacion)="data">
                    {{ data.item.fecha_creacion | moment}}
                  </template>
                  <template #cell(fecha_modificacion)="data">
                    {{ data.item.fecha_modificacion | moment}}
                  </template>
                  <template #cell(estatus)="data">
                    <span
                      class="badge badge-pill bg-success font-size-11"
                      :class="{
                        'bg-danger': `${data.item.estatus}` === '0',
                        'bg-success': `${data.item.estatus}` === '1',
                        'bg-warning': `${data.item.estatus}` === '2',
                      }"
                      >{{
                        data.item.estatus == 0
                          ? "Desactivada"
                          : data.item.estatus === 1
                          ? "Activada"
                          : "Perdida"
                      }}</span
                    >
                  </template>
                  <template #cell(edit)="data">
                    <v-btn
                      icon
                      small
                      @click="handleEdit(data.item.id_usuario)"
                    >
                      <i style="color: #09a5c7" class="bx bxs-pencil"></i>
                    </v-btn>
                    <v-btn
                      icon
                      small
                      @click="handleDelete(data.item.id_usuario)"
                    >
                      <i style="color: #e73484" class="bx bx-trash"></i>
                    </v-btn>
                  </template>
                </b-table>
              </v-col>
            </v-row>
            <v-row>
              <div class="col-sm-12 col-md-6">
                <v-divider class="mx-2" inset vertical></v-divider>
                Mostrando {{ perPage }} de {{ totalRegistros }} registros
              </div>
              <div class="col-sm-12 col-md-6 text-md-end pr-10">
                <b-pagination
                  align="right"
                  v-model="currentPage"
                  :total-rows="totalRegistros / perPage"
                  :per-page="perPage"
                  first-text="Primera"
                  prev-text="Anterior"
                  next-text="Siguiente"
                  last-text="Última"
                ></b-pagination>
              </div>
            </v-row>
          </div>
        </v-card>
      </v-col>
      <!-- end col -->
    </v-row>
    <!-- end row -->
  </Layout>
</template>

<style scoped>
.b-table-woman > thead {
  background-color: azure;
}
</style>